 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"36b7808d7b4aead544f6c629b4e20825912f001a","1":"styles","2":"8e3ce0e79e655df6ed7b44caabd6a4a7608932f8","3":"49e743c072ea52146faed67c15ef2f581a735e93","4":"928f49ee816445fb0f23aede1d9158d6968cbf10","5":"4aaeb7c43ea7db3883dd0eb24a63e3b5e00cba01","6":"2416a2f37e731cfd56c8c6e4d8d429f8b3c65e1b","7":"4a871b6a780a1943f1b62cddab7af85eccc6a59e","8":"8fcd747d80629a519cb46205b6f011db7af3c1c4","12":"component---node-modules-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-arquitectonico-index-js","15":"component---src-pages-blog-js","16":"component---src-pages-contacto-js","17":"component---src-pages-escenico-index-js","18":"component---src-pages-index-js","19":"component---src-pages-osram-aeropuertos-js","20":"component---src-pages-osram-cine-js","21":"component---src-pages-osram-entretenimiento-js","22":"component---src-pages-osram-index-js","23":"component---src-pages-osram-medicina-js","24":"component---src-pages-osram-proyeccion-js","25":"component---src-pages-osram-purificacion-js","26":"component---src-pages-politicas-de-garantia-js","27":"component---src-pages-producto-js","28":"component---src-pages-productos-arquitectural-js","29":"component---src-pages-productos-escenica-js","30":"component---src-pages-productos-index-js","31":"component---src-pages-proyecto-js","32":"component---src-pages-proyectos-js","33":"component---src-pages-quienes-somos-js","34":"component---src-pages-soluciones-index-js","35":"component---src-templates-categories-js","36":"component---src-templates-posts-js","37":"component---src-templates-products-js","38":"component---src-templates-projects-js","39":"component---src-templates-solution-js","40":"component---src-templates-tags-js"}[chunkId]||chunkId) + "-" + {"0":"c649757d0c0127b2ca88","1":"e9d24b1846c7d6eb9685","2":"6ae6085a00d8f6e29e6f","3":"e46fce9dbb9ede1d887a","4":"17311ee14f1761b6bca9","5":"7f27c29c7148011fa866","6":"4f0f82cb56c062a98b3b","7":"85f8e9c1c57e13f783a3","8":"a68a5afcffca0448850c","12":"148195328539c5de62b4","13":"de46e969a0f5edd25d42","14":"85b18c01998cc6fb506b","15":"986b2f71d867a96b8f3b","16":"3c2431fac8f669a2bb8f","17":"4d8c947791b5be1e0df6","18":"f4f36fb768047cf1960d","19":"17caac01709138bb6047","20":"da85e97965cf4b7e2d4b","21":"399fda26453ed4d0dd81","22":"b72e702ed17396a62308","23":"72d27faf43caceeac818","24":"bb2a2f7e03b4bbd54ab1","25":"295392546b3c2d1e3f71","26":"a4cbf674f99dda44470e","27":"9ca151928d254e892484","28":"9b51a22205b2c59106a2","29":"35c1239e2d36eb4e375d","30":"a88eef336d84487b5dba","31":"bc13323dc36552ad963f","32":"8a862ca82de049067b3d","33":"ab429c355f05cd528e52","34":"4111aea43b7f7afa8eb0","35":"c7d7f3d59acc93a9b8dc","36":"aec4302c670afe91afa1","37":"76b2b79e51108e80796c","38":"7c03155ca9ebecf4dc75","39":"d7f2fdb403d7a36c55dd","40":"1193d88c73d620209e20"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"36b7808d7b4aead544f6c629b4e20825912f001a","1":"styles","2":"8e3ce0e79e655df6ed7b44caabd6a4a7608932f8","3":"49e743c072ea52146faed67c15ef2f581a735e93","4":"928f49ee816445fb0f23aede1d9158d6968cbf10","5":"4aaeb7c43ea7db3883dd0eb24a63e3b5e00cba01","6":"2416a2f37e731cfd56c8c6e4d8d429f8b3c65e1b","7":"4a871b6a780a1943f1b62cddab7af85eccc6a59e","8":"8fcd747d80629a519cb46205b6f011db7af3c1c4","12":"component---node-modules-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-arquitectonico-index-js","15":"component---src-pages-blog-js","16":"component---src-pages-contacto-js","17":"component---src-pages-escenico-index-js","18":"component---src-pages-index-js","19":"component---src-pages-osram-aeropuertos-js","20":"component---src-pages-osram-cine-js","21":"component---src-pages-osram-entretenimiento-js","22":"component---src-pages-osram-index-js","23":"component---src-pages-osram-medicina-js","24":"component---src-pages-osram-proyeccion-js","25":"component---src-pages-osram-purificacion-js","26":"component---src-pages-politicas-de-garantia-js","27":"component---src-pages-producto-js","28":"component---src-pages-productos-arquitectural-js","29":"component---src-pages-productos-escenica-js","30":"component---src-pages-productos-index-js","31":"component---src-pages-proyecto-js","32":"component---src-pages-proyectos-js","33":"component---src-pages-quienes-somos-js","34":"component---src-pages-soluciones-index-js","35":"component---src-templates-categories-js","36":"component---src-templates-posts-js","37":"component---src-templates-products-js","38":"component---src-templates-projects-js","39":"component---src-templates-solution-js","40":"component---src-templates-tags-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"8dd69e0509c55df54911","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
